export interface ApiEndpointI {
  titulo: string;
  urlConsultar: string;
  urlDescargar: string;
}

const APP_API = window.configs.REACT_APP_API;

export const listaEndpointsPlanes: ApiEndpointI[] = [
  {
    titulo: "Listado de Normativas",
    urlConsultar: "/normativa",
    urlDescargar: "/normativa",
  },
  {
    titulo: "Listado de Diseños curriculares",
    urlConsultar: "/disenio-curricular",
    urlDescargar: "/disenio-curricular",
  },
  {
    titulo: "Listado de Planes de estudio",
    urlConsultar: "/plan-estudio",
    urlDescargar: "/plan-estudio",
  },
  {
    titulo: "Listado de Cajas curriculares",
    urlConsultar: "/plan-estudio",
    urlDescargar: "/plan-estudio",
  },
  {
    titulo: "Listado de Títulos",
    urlConsultar: "/titulo",
    urlDescargar: "/titulo",
  },
  {
    titulo: "Listado de Niveles",
    urlConsultar: "/nivel",
    urlDescargar: "/nivel",
  },
  {
    titulo: "Listado de Opciones pedagógicas",
    urlConsultar: "/opcion-pedagogica",
    urlDescargar: "/opcion-pedagogica",
  },
  {
    titulo: "Listado de Modalidades",
    urlConsultar: "/modalidad",
    urlDescargar: "/modalidad",
  },
  {
    titulo: "Listado de Áreas",
    urlConsultar: "/areas",
    urlDescargar: "/areas",
  },
  {
    titulo: "Listado de Ciclos",
    urlConsultar: "/ciclo",
    urlDescargar: "/ciclo",
  },
  {
    titulo: "Listado de Combinatorias",
    urlConsultar: "/modalidad-nivel-opcion-pedagogica",
    urlDescargar: "/modalidad-nivel-opcion-pedagogica",
  },
  {
    titulo: "Listado de Orientaciones",
    urlConsultar: "/orientacion",
    urlDescargar: "/orientacion",
  },
  {
    titulo: "Listado de Certificaciones",
    urlConsultar: "/certificacion",
    urlDescargar: "/certificacion",
  },
  {
    titulo: "Listado de Tipos de Espacio",
    urlConsultar: "/tipo-espacio",
    urlDescargar: "/tipo-espacio",
  },
  {
    titulo: "Listado de Espacios Curriculares",
    urlConsultar: "/espacio-curricular",
    urlDescargar: "/espacio-curricular",
  },
  {
    titulo: "Listado de Especialidades",
    urlConsultar: "/especialidad",
    urlDescargar: "/especialidad",
  },
];
